// Mapbox integration note:
// We don't use Mapbox's SearchBox UI; search is handled via Elastic AppSearch
// and results are sent to Mapbox components. This plugin keeps a minimal
// factory in case we later need Mapbox's search utilities.

import { MapboxSearchBox } from '@mapbox/search-js-web'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const token = (config.public as any)?.MAPBOX_ACCESS_TOKEN || (config as any).MAPBOX_API_KEY

  const createSearchBox = (options?: Record<string, any>) => {
    const instance = new (MapboxSearchBox as any)({
      accessToken: token,
      ...(options || {}),
    })
    return instance as any
  }

  return {
    provide: {
      createMapboxSearchBox: createSearchBox,
    }
  }
})